export * from './ManifestoServiceAdapter'